<template>
  <div>
    <div class="p-grid p-justify-center">
      <div style="margin-top: 15vh">
        <div v-if="checkInterval">
          <h1 class="title">{{ $t("Activity.title") }}</h1>
          <img class="centeredGif" :src="`${baseURL}/diamond.gif`" />
        </div>
        <div v-else>
          <Button class="p-button-lg p-button-secondary" @click="goRouter('/')">
            {{ $t("Activity.dashboard_back") }}</Button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  data() {
    return {
      value: 1,
      value2: 1,
      busyAction: false,
      checkInterval: null,
    };
  },
  created() {},
  methods: {
    startChecking(activity_id) {
      console.log("Start checking " + activity_id);
      this.busyAction = true;
      this.checkInterval = setInterval(() => {
        this.getActivity(activity_id);
      }, 2000);
    },
    getActivity(activity_id) {
      api
        .getActivity(activity_id)
        .then(response => {
          var x = response.data;
          if (x.finished) {
            this.makeToast("success", this.$t("Toast.success"));
            this.busyAction = true;
            clearInterval(this.checkInterval);
            this.checkInterval = null;
            this.setCurrentLeagueSeasonId(x.league_id, x.season_id);
            // this.refreshLeagueInformation("/")
          } else if (x.error) {
            this.makeToast("error", this.$t("Toast.error.something_wrong"));
            this.busyAction = true;
            clearInterval(this.checkInterval);
            this.checkInterval = null;
            this.refreshLeagueInformation("/");
          } else {
            console.log("Keep checking....", this.busyAction);
          }
        })
        .catch(e => {
          return false;
        });
    },
  },
  mounted() {
    console.log(this.$route.params);
    this.startChecking(this.$route.params.id);
  },
};
</script>

<style scoped lang="scss"></style>
